import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PageLoader, AddEditApp } from '@app/components';
import { addDetailsBreadcrumb, handleGetApplication, setExceptionHandler, removeDetailsBreadcrumb } from '@app/store/actions';
import { RouteComponentProps } from 'react-router';
import { ApplicationInterfaceTypeUnion } from '@app/components/SSOApps/addEditAppTabs/appContext';

const AppLibraryDetailsPage = (props: RouteComponentProps<{ id: string }>) => {
    let app: ApplicationInterfaceTypeUnion = useSelector((state: any) => state.appLibrary.app);

    const loadingData: any = useSelector((state: any) => state.basic.loadingData);
    const dispatch = useDispatch();
    const appId: string = props.match.params.id;

    useEffect(() => {
        dispatch(handleGetApplication(appId));
        dispatch(setExceptionHandler(true));

        return () => {
            dispatch(removeDetailsBreadcrumb());
        };
    }, []);

    useEffect(() => {
        dispatch(addDetailsBreadcrumb(app.DisplayName));
    }, [app]);

    return (
        <>
            {loadingData && <PageLoader useOverlay={true} />}
            {!loadingData && app.Id !== undefined &&
                <>
                    <AddEditApp appStageType={1} app={app} closeListModal={() => { }} />
                </>
            }
        </>
    );
};

export default AppLibraryDetailsPage;

